/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExfOfacEmulatorV1OfacEmulatorEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXF_OFAC_EMULATOR_V1_OFAC_EMULATOR_EVENT_ENTITY_NAME = 'exf.ofac.emulator.v1.OfacEmulatorEvent';
export const exfOfacEmulatorV1OfacEmulatorEventEntity = new schema.Entity<ExfOfacEmulatorV1OfacEmulatorEvent>(EXF_OFAC_EMULATOR_V1_OFAC_EMULATOR_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExfOfacEmulatorV1OfacEmulatorEvent) => `${entity.metadata?.eventId}` });

